import rpcAgents from './rpc/rpcAgents';

/**
 * Get agent by ID
 * Now uses RPC: /api/:company/rpc/agents/get
 */
export async function getAgentById(company: string, agentId: string) {
  const { data } = await rpcAgents.getById(agentId);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to load agent profile');
}

/**
 * List all agents
 * Now uses RPC: /api/:company/rpc/agents/list
 */
export async function getAgents(company: string, params?: { isBlocked?: boolean; isArchived?: boolean; page?: number; limit?: number }) {
  const { data } = await rpcAgents.list(params);
  // RPC returns { ok: true, data, total } or { ok: false, error }
  if (data.ok) {
    return {
      agents: data.data || [],
      total: data.total || (data.data || []).length
    };
  }
  throw new Error(data.error || 'Failed to fetch agents');
}

/**
 * Create new agent
 * Now uses RPC: /api/:company/rpc/agents/create
 */
export async function createAgent(
  company: string,
  payload: {
    fullName: string;
    email: string;
    phone: string;
    password: string;
  }
) {
  const { data } = await rpcAgents.create(payload);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to create agent');
}

/**
 * Update agent
 * Now uses RPC: /api/:company/rpc/agents/update
 */
export async function updateAgent(
  company: string,
  agentId: string,
  payload: {
    fullName?: string;
    email?: string;
    phone?: string;
  }
) {
  const { data } = await rpcAgents.update(agentId, payload);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to update agent profile');
}

/**
 * Archive/unarchive agent (replaces delete)
 * Now uses RPC: /api/:company/rpc/agents/archive
 */
export async function archiveAgent(company: string, agentId: string, isArchived: boolean) {
  const { data } = await rpcAgents.archive(agentId, isArchived);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to archive agent');
}

/**
 * Delete agent (deprecated - use archiveAgent instead)
 * @deprecated Use archiveAgent instead
 */
export async function deleteAgent(company: string, agentId: string) {
  const { data } = await rpcAgents.delete(agentId);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to delete agent');
}

